<template>
  <div>
    <div class="progress" :style="progress_style">
      <div class="progress__progress-bar" :style="bar_style"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    val: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    size: {
      type: Number,
      default: 3
    },
    bgColor: {
      type: String,
      default: '#eee'
    },
    barColor: {
      type: String,
      default: '#2196f3' // match .blue color to Material Design's 'Blue 500' color
    },
    barTransition: {
      type: String,
      default: 'all 0.5s ease'
    },
    spacing: {
      type: Number,
      default: 4
    }
  },
  computed: {
    pct() {
      var pct = (this.val / this.max) * 100
      pct = pct.toFixed(2)
      return Math.min(pct, this.max)
    },
    progress_style() {
      var style = {
        background: this.bgColor
      }
      return style
    },
    bar_style() {
      var style = {
        background: this.barColor,
        width: this.pct + '%',
        height: this.size + 'px',
        transition: this.barTransition
      }
      return style
    }
  }
}
</script>
